import { useWeb3React } from '@web3-react/core'
import TokenLogo from '~/components/TokenLogo'
import { Column } from '~/components/Layout'
import { formatFormAmount } from '~/utils/numbers'
import { truncateAddress } from '~/utils/truncateAddress'
import { getNetworkLogo } from '~/utils/chain'
import { formatAmount } from '~/components/Exchange/helpers'
import { OrderedSpotSwapToken } from './types'
import styled from 'styled-components'

interface Props {
  token: OrderedSpotSwapToken
  searchText: string
  showNetworkBadge: boolean
  onSelect: (token: ERC20Token) => void
}

const TokenListItem: React.FC<Props> = ({
  token,
  searchText,
  showNetworkBadge,
  onSelect,
}) => {
  const { account } = useWeb3React()
  const { chainId, logo, symbol, balance, priceUSD, address, name } = token
  const networkLogo = getNetworkLogo(chainId)

  return (
    <ListItem onClick={() => onSelect(token)}>
      <TokenLogo
        large
        logo={logo}
        symbol={symbol}
        space={0}
        networkLogo={networkLogo}
        showNetworkBadge={showNetworkBadge}
      />

      <div className="item-right">
        <Column>
          <StyledSymbol>{symbol}</StyledSymbol>

          <span className="token-name">
            {searchText && searchText.startsWith('0x')
              ? truncateAddress(address)
              : name}
          </span>
        </Column>
        {account && Number(balance) ? (
          <div className="token-account-info">
            <span className="balance">{formatFormAmount(balance, 4)}</span>
            {Number(priceUSD) && (
              <span className="priceUSD">${formatAmount(priceUSD, 2)}</span>
            )}
          </div>
        ) : null}
      </div>
    </ListItem>
  )
}

export default TokenListItem

const ListItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #fafafc;
  }

  .item-right {
    border-bottom: 0.5px solid #eaecf6;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding: 17px 0;
    padding-right: 17.5px;
    min-height: 70px;
    margin-left: 8px;
  }

  .token-name {
    font-size: 13px;
    font-weight: 400;
    color: #9598ab;
  }

  .token-user-add {
    font-weight: 300;
    font-size: 13px;
    line-height: 17px;
    color: #9598ab;
  }

  .token-account-info {
    display: inline-flex;
    flex-direction: column;
    text-align: right;
  }

  .balance {
    font-weight: 500;
    font-size: 17px;
    line-height: 15px;
    color: #191c1e;
    margin: 0;
  }

  .priceUSD {
    font-weight: normal;
    font-size: 13px;
    line-height: 11px;
    color: #9598ab;
    margin-top: 9px;
  }
`

const StyledSymbol = styled.div`
  font-size: 17px;
  line-height: 23.15px;
  color: #191c1e;
`
